/* import __COLOCATED_TEMPLATE__ from './help-popover-header.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();